import { GetStaticPaths, GetStaticProps } from 'next';
import React from 'react';
import Layout from '@/components/Layout';
import ValuationInvestments from '@/containers/sebiUpdates/ValuationInvestments';
import AccreditedInvestor from '@/containers/sebiUpdates/AccreditedInvestor';
import DemattingofAifUnits from '@/containers/sebiUpdates/DemattingofAifUnits';
import RegulatoryReportingByAif from '@/containers/sebiUpdates/RegulatoryReportingByAif';
import StandardPpmAuditFormat from '@/containers/sebiUpdates/StandardPpmAuditFormat';
import TeamOfManagerAif from '@/containers/sebiUpdates/TeamOfManagerAif';
import NISMCertification from '@/pages/resources/nism-certification';
import PerformanceBenchmark from '@/containers/resources/PerformanceBenchmark';
import SebiCircular from '@/containers/sebiUpdates/SebiCircular';
import InvestorSebiAifs from '@/containers/resources/InvestorSebiAifs';
import ProRataAifs from '@/containers/resources/ProRataAifs';
import FrameCategoryAifs from '@/containers/resources/FrameCategoryAifs';
import FundsRegulations from '@/containers/resources/FundsRegulations';

const SebiSlugPage: React.FC<{ slug: string }> = ({ slug }) => (
  <Layout>
    {slug.includes('valuation-of-afis-investments') ? (
      <ValuationInvestments />
    ) : slug.includes('accredited-investor') ? (
      <AccreditedInvestor />
    ) : slug.includes('dematting-of-aif-units') ? (
      <DemattingofAifUnits />
    ) : slug.includes('standardised-ppm-audit-format') ? (
      <StandardPpmAuditFormat />
    ) : slug.includes('team-of-manager-of-AIF') ? (
      <TeamOfManagerAif />
    ) : slug.includes('nsim-certification') ? (
      <NISMCertification />
    ) : slug.includes('performance-benching') ? (
      <PerformanceBenchmark />
    ) : slug.includes('sebi-circular') ? (
      <SebiCircular />
    ) : slug.includes('investment-of-aifs') ? (
      <InvestorSebiAifs />
    ) : slug.includes('pro-rata') ? (
      <ProRataAifs />
    ) : slug.includes('frame-category-aifs') ? (
      <FrameCategoryAifs />
    ) : slug.includes('sebi-aifs-funds-regulations') ? (
      <FundsRegulations />
    ) : (
      <RegulatoryReportingByAif />
    )}
  </Layout>
);

export default SebiSlugPage;

export const getStaticPaths: GetStaticPaths = async () => ({
  paths: [],
  fallback: 'blocking',
});

export const getStaticProps: GetStaticProps = async (ctx) => {
  const slug = ctx.params?.slug;

  return {
    props: {
      slug,
    },
  };
};
